import { useAccount, useAccountEffect, useChainId, useSwitchChain } from 'wagmi';
import { base } from 'wagmi/chains';

interface UseAutoChainSwitchReturn {
  isSwitching: boolean;
  showBanner: boolean;
}

export const useAutoChainSwitch = (): UseAutoChainSwitchReturn => {
  const { isConnected, chainId: walletChainId } = useAccount();
  const appChainId = useChainId();
  // normally wagmi will switch user wallet to App chain id on switchChain,
  // or wagmi will follow user wallet chainId on chainChanged event, if wagmi config has that chain,
  // so chains will always match if possible
  const showBanner = isConnected && !!walletChainId && walletChainId !== appChainId;

  const { switchChain, isPending } = useSwitchChain();

  useAccountEffect({
    onConnect: ({ chainId }) => {
      // eager-connection on App load doesn't auto-switch user wallet to app chain without this
      if (chainId !== base.id) {
        switchChain({ chainId: base.id });
      }
    },
  });

  return {
    isSwitching: isPending,
    showBanner,
  };
};
